import { Alert, Box } from '@mui/material';
import React from 'react';
import { InvestorStatementEmailTemplateData } from '../../../models/admin/InvestorStatement';
import { Palette } from 'Palette';
import { EmailPreviewIframeRef } from '../EmailPreviewIframe';
import { InvitationEmailEditHintPosition } from '../generateInvitationEmailTypes';
import StatementEmailComposeFooter from './StatementEmailComposeFooter';
import StatementEmailComposeHeader from './StatementEmailComposeHeader';
import StatementEmailContentEditor from './StatementEmailContentEditor';
import StatementEmailFieldsSection from './StatementEmailFieldsSection';

const tone: keyof typeof Palette = 'default';

interface StatementEmailComposePanelProps {
  templateData: InvestorStatementEmailTemplateData;
  fromEmail: string;
  onFromEmailChange: (value: string) => void;
  subject: string;
  onSubjectChange: (value: string) => void;
  customHtml: string;
  emailPreviewRef: React.RefObject<EmailPreviewIframeRef>;
  iframeContainerRef: React.RefObject<HTMLDivElement>;
  showSpeechBubble: boolean;
  elementPosition: InvitationEmailEditHintPosition | null;
  sending: boolean;
  error: string | null;
  onContentChange: (html: string) => void;
  onEnterEditMode: () => void;
  onElementPosition: (position: { top: number; left: number }) => void;
  onHideSpeechBubble: () => void;
  onCancel: () => void;
  onSend: () => void;
}

const StatementEmailComposePanel: React.FC<StatementEmailComposePanelProps> = ({
  templateData,
  fromEmail,
  onFromEmailChange,
  subject,
  onSubjectChange,
  customHtml,
  emailPreviewRef,
  iframeContainerRef,
  showSpeechBubble,
  elementPosition,
  sending,
  error,
  onContentChange,
  onEnterEditMode,
  onElementPosition,
  onHideSpeechBubble,
  onCancel,
  onSend,
}) => (
  <Box
    sx={{
      border: `1px solid ${Palette[tone].border}`,
      borderRadius: '8px',
      backgroundColor: 'white',
    }}
  >
    <StatementEmailComposeHeader />

    {error && (
      <Box sx={{ px: 2, pt: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    )}

    <StatementEmailFieldsSection
      templateData={templateData}
      fromEmail={fromEmail}
      onFromEmailChange={onFromEmailChange}
      subject={subject}
      onSubjectChange={onSubjectChange}
    />

    <StatementEmailContentEditor
      templateData={templateData}
      customHtml={customHtml}
      emailPreviewRef={emailPreviewRef}
      iframeContainerRef={iframeContainerRef}
      showSpeechBubble={showSpeechBubble}
      elementPosition={elementPosition}
      onContentChange={onContentChange}
      onEnterEditMode={onEnterEditMode}
      onElementPosition={onElementPosition}
      onHideSpeechBubble={onHideSpeechBubble}
    />

    <StatementEmailComposeFooter sending={sending} onCancel={onCancel} onSend={onSend} />
  </Box>
);

export default StatementEmailComposePanel;
